module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/efforts/effort-form/effort-form.component.sass
// module id = ./src/app/efforts/effort-form/effort-form.component.sass
// module chunks = main